import React from 'react';
import BannerContainer from './BannerContainer';
import { RecsGridItem, RecsGridItemProps } from './Recs';

const MIN_PRODUCTS_FOR_PLACEMENTS = 30;
export const PLACEMENT_CONTAINERS = [
  { position: 2, placement: RecsGridItem },
  { position: 4, placement: RecsGridItem },
  {
    position: 6,
    // eslint-disable-next-line react/jsx-props-no-spreading
    placement: (props: RecsGridItemProps) => <RecsGridItem {...props} lastOfType />,
  },
  { position: 6, placement: BannerContainer },
  { position: 36, placement: BannerContainer },
  { position: 54, placement: BannerContainer },
  { position: 72, placement: BannerContainer },
].reverse();

export const withPlacementContainers = (items: React.JSX.Element[]) => {
  if (items.length < MIN_PRODUCTS_FOR_PLACEMENTS) return items;

  const updatedItems = [...items];
  PLACEMENT_CONTAINERS.forEach(({ position, placement: Placement }, idx) => {
    if (position > items.length) return;
    // eslint-disable-next-line react/no-array-index-key
    updatedItems.splice(position, 0, <Placement key={`placement-${idx}`} itemKey={position} />);
  });

  return updatedItems;
};
